/* Makeloo V4 — Wishlist (localStorage) + Quick-add (AJAX cart). No app, no login. */
(function () {
  'use strict';
  var KEY = 'makeloo_wishlist_v1';

  function read() {
    try {
      var v = JSON.parse(localStorage.getItem(KEY));
      return Array.isArray(v) ? v : [];
    } catch (e) {
      return [];
    }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
  }
  function toggle(handle) {
    if (!handle || !/^[a-z0-9-]+$/.test(handle)) { return false; }
    var list = read();
    var i = list.indexOf(handle);
    if (i === -1) { list.push(handle); } else { list.splice(i, 1); }
    write(list);
    return i === -1; // true if just added
  }

  /* ---- Toast ---- */
  var toastEl;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'v4-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.classList.add('is-visible');
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 2600);
  }

  /* ---- UI sync ---- */
  function syncButtons() {
    var list = read();
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var active = list.indexOf(btn.getAttribute('data-product-handle')) !== -1;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      btn.setAttribute('aria-label', active ? 'Retirer des favoris' : 'Ajouter aux favoris');
    });
  }
  function syncCount() {
    var n = read().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = n;
      if (n > 0) { el.removeAttribute('hidden'); } else { el.setAttribute('hidden', ''); }
    });
  }

  /* ---- Cart count ---- */
  function refreshCart() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var n = c.item_count || 0;
        var link = document.querySelector('[data-cart-link]');
        var badge = document.querySelector('.v4-header__cart-count');
        if (!badge && link && n > 0) {
          badge = document.createElement('span');
          badge.className = 'v4-header__cart-count';
          link.appendChild(badge);
        }
        if (badge) {
          if (n > 0) { badge.textContent = n; badge.style.display = ''; }
          else { badge.style.display = 'none'; }
        }
        /* let the cart drawer re-render items, shipping bar and upsell */
        document.dispatchEvent(new CustomEvent('v4cart:refresh', { detail: c }));
      })
      .catch(function () {});
  }

  /* ---- Money (favoris render) ---- */
  function money(cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'CAD';
    try {
      return (cents / 100).toLocaleString('fr-CA', { style: 'currency', currency: cur });
    } catch (e) {
      return (cents / 100).toFixed(2) + ' $';
    }
  }

  /* ---- Favoris page render ---- */
  function renderFavoris() {
    var wrap = document.querySelector('[data-wishlist-list]');
    if (!wrap) { return; }
    var empty = document.querySelector('[data-wishlist-empty]');
    var handles = read();
    if (!handles.length) {
      wrap.innerHTML = '';
      if (empty) { empty.removeAttribute('hidden'); }
      return;
    }
    if (empty) { empty.setAttribute('hidden', ''); }
    wrap.innerHTML = '';
    handles.forEach(function (h) {
      fetch('/products/' + encodeURIComponent(h) + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { if (!r.ok) { throw 0; } return r.json(); })
        .then(function (p) {
          /* B1 — build card via DOM API, no innerHTML with external data */
          var safeUrl = (p.url || '').charAt(0) === '/' ? p.url : '/';

          var card = document.createElement('div');
          card.className = 'pcard';

          var link = document.createElement('a');
          link.className = 'pcard__link';
          link.href = safeUrl;

          var media = document.createElement('div');
          media.className = 'pcard__media';

          var wishBtn = document.createElement('button');
          wishBtn.className = 'pcard__wish is-active';
          wishBtn.type = 'button';
          wishBtn.setAttribute('data-wishlist-toggle', '');
          wishBtn.setAttribute('data-product-handle', p.handle || '');
          wishBtn.setAttribute('aria-pressed', 'true');
          wishBtn.setAttribute('aria-label', 'Retirer des favoris');
          wishBtn.innerHTML = '<svg viewBox="0 0 24 24"><path d="M12 21s-7-4.35-9.5-9A5.5 5.5 0 0 1 12 6.5 5.5 5.5 0 0 1 21.5 12c-2.5 4.65-9.5 9-9.5 9Z"/></svg>';
          media.appendChild(wishBtn);

          if (p.featured_image) {
            var img = document.createElement('img');
            img.src = p.featured_image;
            img.alt = p.title || '';
            img.loading = 'lazy';
            media.appendChild(img);
          }

          link.appendChild(media);

          var body = document.createElement('div');
          body.className = 'pcard__body';

          var nameEl = document.createElement('h3');
          nameEl.className = 'pcard__name';
          nameEl.textContent = p.title || '';
          body.appendChild(nameEl);

          var prices = document.createElement('div');
          prices.className = 'pcard__prices';
          var priceSpan = document.createElement('span');
          priceSpan.className = 'pcard__price';
          priceSpan.textContent = money(p.price);
          prices.appendChild(priceSpan);
          body.appendChild(prices);

          link.appendChild(body);
          card.appendChild(link);
          wrap.appendChild(card);
        })
        .catch(function () {
          /* B2 — product 404/unavailable: remove from localStorage and sync UI */
          var list = read();
          var idx = list.indexOf(h);
          if (idx !== -1) {
            list.splice(idx, 1);
            write(list);
            syncCount();
            syncButtons();
          }
        });
    });
  }

  /* ---- Click delegation ---- */
  document.addEventListener('click', function (e) {
    var wb = e.target.closest('[data-wishlist-toggle]');
    if (wb) {
      e.preventDefault();
      e.stopPropagation();
      var added = toggle(wb.getAttribute('data-product-handle'));
      syncButtons();
      syncCount();
      toast(added ? 'Ajouté aux favoris' : 'Retiré des favoris');
      if (!added && document.querySelector('[data-wishlist-list]')) { renderFavoris(); }
      return;
    }
    var qa = e.target.closest('[data-quick-add]');
    if (qa) {
      e.preventDefault();
      e.stopPropagation();
      var url = qa.getAttribute('data-product-url');
      if (url) { window.location.href = url; return; }
      var id = qa.getAttribute('data-variant-id');
      if (!id || qa.classList.contains('is-loading')) { return; }
      var i18n = window.V4CartI18n || {};
      var prev = qa.textContent;
      qa.classList.add('is-loading');
      qa.textContent = i18n.adding || 'Ajout…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
      })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (res) {
          qa.classList.remove('is-loading');
          qa.textContent = prev;
          if (!res.ok) { toast((res.d && res.d.description) || i18n.unavailable || 'Indisponible'); return; }
          refreshCart();
          toast(i18n.addedShort || 'Ajouté au panier');
        })
        .catch(function () {
          qa.classList.remove('is-loading');
          qa.textContent = prev;
          toast(i18n.networkError || 'Erreur réseau');
        });
    }
  });

  /* ---- Init ---- */
  function init() { syncButtons(); syncCount(); renderFavoris(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
